import { Params, RouterStateSnapshot, Data } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { Injectable } from '@angular/core';

export interface RouterStateUrl {
    // Url to the current route
    url: string;
    // Any params in the path to the route
    params: Params;
    // Current query params
    queryParams: Params;
    // Route data of the current route
    data: Data;
}

@Injectable()
export class RouterSerializer implements RouterStateSerializer<RouterStateUrl> {
    serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        let route = routerState.root;
        let params = route.params;

        while (route.firstChild) {
            route = route.firstChild;
            params = { ...params, ...route.params };
        }

        const {
            url,
            root: { queryParams }
        } = routerState;

        return { url, params, queryParams, data: route.data };
    }
}
